import type { RouteLocationAsRelativeGeneric, RouteLocationRaw } from 'vue-router';

const sectionToRouteMap = {
    allgemeine_angaben: { name: 'planungsgeschaeft-edit-editor' },
    beteiligte: { name: 'planungsgeschaeft-edit-beteiligte' },
    geschaeftsunterlagen: { name: 'planungsgeschaeft-edit-plaene' },
    abschluss: { name: 'planungsgeschaeft-edit-abschluss' },
    weitere_unterlagen: { name: 'planungsgeschaeft-edit-weitere-unterlagen' },
} as {
    [key: string]: RouteLocationAsRelativeGeneric;
};

/**
 * Maps a Planungsgeschaeft section name to a route configuration.
 * The section name is the section key used in the Backend in several locations (e.g. in the check service etc.).
 * So the sectionname key must correspond to the backend model / services.
 *
 * @param sectionName
 * @returns
 */
export function sectionNameToRoute(sectionName: string | null): RouteLocationAsRelativeGeneric | null {
    if (!sectionName) {
        return null;
    }
    const route = sectionToRouteMap[sectionName];
    if (!route) {
        console.warn('Unknown section name: cannot find route for ' + sectionName);
        return null;
    }
    return route;
}
